import { render, staticRenderFns } from "./photos.vue?vue&type=template&id=023fd758&scoped=true&"
import script from "./photos.vue?vue&type=script&lang=js&"
export * from "./photos.vue?vue&type=script&lang=js&"
import style0 from "./photos.vue?vue&type=style&index=0&id=023fd758&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023fd758",
  null
  
)

export default component.exports